import { DynamicApiRoutes } from "../routes";
import { useApiGet } from "./useApiGet";

export interface IDataAlertEntity {
	target: AlertEntityType;
	type: AlertType;
	alertLimit: number;
	factor?: number;
}

export enum AlertType {
	TooLow = "TooLow",
	TooHigh = "TooHigh",
}
export enum AlertEntityType {
	EggsPerHousedHen = "EggsPerHousedHen",
	AverageEggWeight = "AverageEggWeight",
	CumulativeEggWeight = "CumulativeEggWeight",
	EggLayingPercentage = "EggLayingPercentage",
	AverageHenWeight = "AverageHenWeight",
	FodderConsumption = "FodderConsumption",
	MortalityRate = "MortalityRate",
	WaterConsumptionPerHen = "WaterConsumptionPerHen",
}

export function useProductionDataAlerts(flockId: string) {
	const { result: alerts } = useApiGet<IDataAlertEntity[]>(
		DynamicApiRoutes.ProductionDataAlerts.get(flockId)
	);

	return { alerts };
}

export function useProductionDataAlertsForDate(
	flockId: string,
	date: Date,
	refreshKey?: number
) {
	const { result: alerts, loading } = useApiGet<IDataAlertEntity[]>(
		DynamicApiRoutes.ProductionDataAlerts.getByDate(flockId, date),
		refreshKey
	);

	return { alerts, loading };
}
